import { SAVE_USER_DATA, SAVE_WALLET_DATA } from './actions';
const initialState = {
  userId: '',
  isFirstChapterAssociated: false,
  isSecondChapterAssociated: false,
  isThirdChapterAssociated: false,
  isFirstChapterOwner: false,
  isSecondChapterOwner: false,
  isThirdChapterOwner: false,
  isFounder: false,
  isConnected: false,
  isFakeWallet:false,
  savedDateInSeconds: 0,
  canClaimDaily:false,
  FTStatus: '',
  BBRStatus: '',
  canClaimBBR: false,
  dailyClaimsAmount: 0,
  manceAndLeemonStatus: false,
  isManceTierAssociated: false,
  isManceTierOwner: false,
  isLeemonTierAssociated: false,
  isLeemonTierOwner: false,
  isCardAssociated: false
};

const userReducer = (state = initialState, action:any) => {
  switch (action.type) {
    case SAVE_USER_DATA:
      return {
        ...state,
        userId: action.payload.userId,
        isFirstTierAssociated:  action.payload.isFirstTierAssociated,
        isFirstTierOwner:  action.payload.isFirstTierOwner,
        isSecondTierAssociated:  action.payload.isSecondTierAssociated,
        isSecondTierOwner:  action.payload.isSecondTierOwner,
        isThirdTierAssociated:  action.payload.isThirdTierAssociated,
        isThirdTierOwner:  action.payload.isThirdTierOwner,
        isFourthTierAssociated:  action.payload.isFourthTierAssociated,
        isFourthTierOwner:  action.payload.isFourthTierOwner,
        isFifthTierAssociated: action.payload.isFifthTierAssociated,
        isFifthTierOwner:  action.payload.isFifthTierOwner,
        isFounder: action.payload.isFounder,
        isConnected: action.payload.isConnected,
        savedDateInSeconds: action.payload.savedDateInSeconds,
        canClaimDaily: action.payload.canClaimDaily,
        FTStatus: action.payload.FTStatus,
        BBRStatus: action.payload.BBRStatus,
        canClaimBBR: action.payload.canClaimBBR,
        dailyClaimsAmount: action.payload.dailyClaimsAmount,
        manceAndLeemonStatus: action.payload.manceAndLeemonStatus,
        isManceTierAssociated: action.payload.isManceTierAssociated,
        isManceTierOwner: action.payload.isManceTierOwner,
        isLeemonTierAssociated: action.payload.isLeemonTierAssociated,
        isLeemonTierOwner: action.payload.isLeemonTierOwner,
        isCardAssociated: action.payload.isCardAssociated
      };
    default:
      return state;
  }
};

const walletReducer = (state = initialState, action:any) => {
  switch (action.type) {
    case SAVE_WALLET_DATA:
      return {
        ...state,
        isFakeWallet: action.payload.isFakeWallet
      };
    default:
      return state;
  }
};

export  { userReducer, walletReducer };
